import {
  getSearchState,
  type FlightSearchValues,
} from "@b2bportal/core-flights";
import { TripCategory } from "@overrides/types";
import { createSelector } from "@reduxjs/toolkit";

export const validateFlightSearchValues = ({
  origin,
  destination,
  departureDate,
  returnDate,
  tripCategory,
  passengerCounts,
  multicityRoutes,
}: FlightSearchValues) => {
  if (
    (origin == null || destination == null || departureDate == null) &&
    multicityRoutes.length === 0
  ) {
    return undefined;
  }
  const baseParams = {
    origin,
    destination,
    departureDate,
    passengerCounts,
    tripCategory,
  };
  if (tripCategory === TripCategory.ONE_WAY) {
    return { ...baseParams, tripCategory };
  }

  if (tripCategory === TripCategory.MULTI_CITY) {
    return { ...baseParams, multicityRoutes, tripCategory };
  }

  if (returnDate == null) {
    return undefined;
  }
  return { ...baseParams, returnDate, tripCategory };
};

export const getValidSearchState = createSelector(getSearchState, (params) =>
  validateFlightSearchValues(params)
);
